import { Inventory, InventoryItem } from '@/types';
import { BrewfatherService } from './BrewfatherService';

const emptyInventory = (userId: string): Inventory => ({
	items: [],
	totalItems: 0,
	categories: {
		hops: 0,
		malt: 0,
		yeast: 0,
		equipment: 0,
		other: 0,
		additives: 0
	}
});

export const InventoryService = {
	/**
	 * Get user's inventory from Brewfather using the user's own credentials (same as batches/recipes).
	 * If Brewfather is not connected, returns an empty inventory.
	 */
	getInventory: async (userId: string, authHeader?: Record<string, string>): Promise<Inventory> => {
		if (!authHeader?.Authorization) {
			return emptyInventory(userId);
		}
		try {
			return await BrewfatherService.getInventory(userId, authHeader);
		} catch (error: any) {
			// No credentials or invalid creds: return empty inventory so UI can show "Connect Brewfather"
			if (
				error?.message?.includes('credentials not configured') ||
				error?.message?.includes('Invalid Brewfather credentials')
			) {
				return emptyInventory(userId);
			}
			throw error;
		}
	},

	/**
	 * Add an inventory item
	 */
	addItem: async (userId: string, item: Omit<InventoryItem, 'id' | 'userId' | 'createdAt' | 'updatedAt'>, authHeader?: Record<string, string>): Promise<InventoryItem> => {
		// TODO: Implement when backend is ready
		throw new Error('Not implemented yet');
	},

	/**
	 * Update an inventory item
	 */
	updateItem: async (userId: string, itemId: string, updates: Partial<InventoryItem>, authHeader?: Record<string, string>): Promise<InventoryItem> => {
		// TODO: Implement when backend is ready
		throw new Error('Not implemented yet');
	},

	/**
	 * Delete an inventory item
	 */
	deleteItem: async (userId: string, itemId: string, authHeader?: Record<string, string>): Promise<void> => {
		// TODO: Implement when backend is ready
		throw new Error('Not implemented yet');
	}
};
